import React from 'react';
import { API_URL } from '../config';
import './DMList.css';

function DMList({ dmChannels, currentChannel, onSelectDM, onCloseDM, onShowFriends, user }) {
  return (
    <div className="dm-list">
      <div className="dm-header" onClick={onShowFriends}>
        <div className="dm-title">Friends</div>
      </div>

      <div className="dm-section-header">
        <span>DIRECT MESSAGES</span>
      </div>

      <div className="dm-channels">
        {dmChannels.length === 0 ? (
          <div className="dm-empty">
            <p>No direct messages yet</p>
          </div>
        ) : (
          dmChannels.map(dm => {
            const recipientName = dm.recipient_username || dm.recipient?.username;
            return (
              <div
                key={dm.id}
                className={`dm-item ${currentChannel?.id === dm.id ? 'active' : ''}`}
                onClick={() => onSelectDM(dm)}
              >
                <div className="dm-avatar">
                  {dm.recipient_avatar_url ? (
                    <img src={`${API_URL}${dm.recipient_avatar_url}`} alt={recipientName} />
                  ) : (
                    recipientName?.substring(0, 1).toUpperCase()
                  )}
                </div>
                <div className="dm-info">
                  <div className="dm-name">{recipientName}</div>
                  {dm.last_message && (
                    <div className="dm-last-message">
                      {dm.last_message.substring(0, 30)}
                      {dm.last_message.length > 30 ? '...' : ''}
                    </div>
                  )}
                </div>
                <button
                  className="dm-close"
                  onClick={(e) => onCloseDM(dm.id, e)}
                  title="Close DM"
                >
                  ×
                </button>
              </div>
            );
          })
        )}
      </div>

      <div className="user-panel">
        <div className="user-info">
          <div className="user-avatar">
            {user?.username?.substring(0, 1).toUpperCase()}
          </div>
          <div className="user-details">
            <div className="user-name">{user?.username}</div>
            <div className="user-status">Online</div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DMList;
